module.exports = __webpack_public_path__ + "media/svg-new/icon-natureza-2d8d54c5.svg";